const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance hours', '出勤'],
				children: {
					ZZ_KANGYANG_AM10010: {
						name: ['(客製)出勤模擬試算(AB報表)', '(客製)出勤模擬試算(AB報表)', '(客製)出勤模擬試算(AB報表)'],
						url: '/zz_kangyang_am10010',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};